import { __decorate } from "tslib";
import * as _eventsApi from './eventsource.js';
import { EventMap } from './eventsource.js';
import { define, definitions, mixinRules } from './mixins.js';
import { omit, transform } from './tools.js';
const { strings, on, off, once, trigger5, trigger2, trigger3 } = _eventsApi;
let _idCount = 0;
function uniqueId() {
    return 'l' + _idCount++;
}
export { EventMap };
let Messenger = class Messenger {
    static onDefine({ localEvents, _localEvents, properties }, BaseClass) {
        if (localEvents || _localEvents) {
            const eventsMap = new EventMap(this.prototype._localEvents);
            localEvents && eventsMap.addEventsMap(localEvents);
            _localEvents && eventsMap.merge(_localEvents);
            this.prototype._localEvents = eventsMap;
        }
        if (properties) {
            Object.defineProperties(this.prototype, transform({}, properties, toPropertyDescriptor));
        }
    }
    constructor() {
        this._events = void 0;
        this._listeningTo = void 0;
        this.cid = uniqueId();
        this.initialize.apply(this, arguments);
    }
    initialize() { }
    on(events, callback, context) {
        if (typeof events === 'string')
            strings(on, this, events, callback, context);
        else
            for (let name in events)
                strings(on, this, name, events[name], context || callback);
        return this;
    }
    once(events, callback, context) {
        if (typeof events === 'string')
            strings(once, this, events, callback, context);
        else
            for (let name in events)
                strings(once, this, name, events[name], context || callback);
        return this;
    }
    off(events, callback, context) {
        if (!events)
            off(this, void 0, callback, context);
        else if (typeof events === 'string')
            strings(off, this, events, callback, context);
        else
            for (let name in events)
                strings(off, this, name, events[name], context || callback);
        return this;
    }
    trigger(name, a, b, c, d, e) {
        if (d !== void 0 || e !== void 0)
            trigger5(this, name, a, b, c, d, e);
        else if (c !== void 0)
            trigger3(this, name, a, b, c);
        else
            trigger2(this, name, a, b);
        return this;
    }
    listenTo(source, a, b) {
        if (source) {
            addReference(this, source);
            source.on(a, !b && typeof a === 'object' ? this : b, this);
        }
        return this;
    }
    listenToOnce(source, a, b) {
        if (source) {
            addReference(this, source);
            source.once(a, !b && typeof a === 'object' ? this : b, this);
        }
        return this;
    }
    stopListening(a_source, a, b) {
        const { _listeningTo } = this;
        if (_listeningTo) {
            const removeAll = !(a || b), second = !b && typeof a === 'object' ? this : b;
            if (a_source) {
                const source = _listeningTo[a_source.cid];
                if (source) {
                    if (removeAll)
                        delete _listeningTo[a_source.cid];
                    source.off(a, second, this);
                }
            }
            else if (a_source == null) {
                for (let cid in _listeningTo)
                    _listeningTo[cid].off(a, second, this);
                if (removeAll)
                    (this._listeningTo = void 0);
            }
        }
        return this;
    }
    dispose() {
        if (this._disposed)
            return;
        this.stopListening();
        this.off();
        this._disposed = true;
    }
};
Messenger = __decorate([
    define,
    definitions({
        properties: mixinRules.merge,
        localEvents: mixinRules.merge
    })
], Messenger);
export { Messenger };
export const Events = omit(Messenger.prototype, 'constructor', 'initialize');
function toPropertyDescriptor(x) {
    if (x) {
        return typeof x === 'function' ? { get: x, configurable: true } : x;
    }
}
function addReference(listener, source) {
    const listeningTo = listener._listeningTo || (listener._listeningTo = Object.create(null)), cid = source.cid || (source.cid = uniqueId());
    listeningTo[cid] = source;
}
//# sourceMappingURL=events.js.map